import { render, staticRenderFns } from "./SalonOptionCard.vue?vue&type=template&id=cb29c234&scoped=true"
import script from "./SalonOptionCard.vue?vue&type=script&lang=js"
export * from "./SalonOptionCard.vue?vue&type=script&lang=js"
import style0 from "./SalonOptionCard.vue?vue&type=style&index=0&id=cb29c234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb29c234",
  null
  
)

export default component.exports